import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChargeLocations = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16 12.3636C16 18.0909 9 23 9 23C9 23 2 18.0909 2 12.3636C2 10.4107 2.7375 8.53771 4.05025 7.15676C5.36301 5.77581 7.14348 5 9 5C10.8565 5 12.637 5.77581 13.9497 7.15676C15.2625 8.53771 16 10.4107 16 12.3636Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 15C10.3807 15 11.5 13.8807 11.5 12.5C11.5 11.1193 10.3807 10 9 10C7.61929 10 6.5 11.1193 6.5 12.5C6.5 13.8807 7.61929 15 9 15Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6556 1L16 6.4H19.2901L18.9245 10L22.5802 4.6H19.2901L19.6556 1Z",
			fill: "#DBE4E8",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgChargeLocations);
export { ForwardRef as ReactComponent };
